import React from 'react';
import { Dialog, DialogContent, IconButton, Box } from '@mui/material';
import Iconify from 'src/components/iconify';
import CompetitorModalContent from './CompetitorModalContent';

interface CompetitorModalProps {
    isOpen: boolean;
    onClose: () => void;
    domain: string;
    workspaceId?: string;
}

export default function CompetitorModal({ 
    isOpen, 
    onClose, 
    domain, 
    workspaceId = '48' 
}: CompetitorModalProps) {
    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            maxWidth="xl"
            fullWidth
            sx={{
                zIndex: 9999,
                '& .MuiDialog-paper': {
                    borderRadius: '12px',
                    maxHeight: '95vh',
                    margin: '16px',
                    zIndex: 9999,
                },
            }}
        >
            <DialogContent sx={{ p: 0, position: 'relative' }}>
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        zIndex: 1,
                        backgroundColor: 'rgba(0, 0, 0, 0.1)',
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.2)',
                        },
                    }}
                >
                    <Iconify icon="mdi:close" />
                </IconButton>
                <Box sx={{ height: '90vh', overflow: 'auto' }}>
                    <CompetitorModalContent domain={domain} />
                </Box>
            </DialogContent>
        </Dialog>
    );
}
